import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UpdateFragmentTranslation, type TranslationData } from '../update-fragment-translation';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { UpdateTranslationApi } from '@/infrastructure/api-functions/core-drafting-api/update-translation-api';
import { TranslateModel } from '../../models/translate-model';

@injectable()
export class UpdateFragmentTranslationImpl implements UpdateFragmentTranslation {
    constructor(
        @inject(TranslateModel)
        private readonly _aiTranslationModel: TranslateModel,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
        @inject(UpdateTranslationApi)
        private readonly _updateTranslationApi: UpdateTranslationApi,
    ) {}

    private get taskId(): string {
        return this._currentTaskService.taskId;
    }

    async updateTranslation(fragment: TranslationData): Promise<void> {
        await this._saveToServer(fragment);
        this._updateToModel(fragment);
    }

    /**
     * 更新翻译片段到本地模型
     * @param fragment 翻译片段
     */
    private _updateToModel(fragment: TranslationData): void {
        this._aiTranslationModel.update(state => {
            const result = state.result[fragment.index];
            result.translation = fragment.original;
            result.graphIndex = 0;
            return state;
        });
    }

    private async _saveToServer(fragment: TranslationData): Promise<void> {
        const taskId = this.taskId;
        console.info(`向服务端发送请求，更新任务「${taskId}」的第「${fragment.index}」片段的译文`);
        return this._updateTranslationApi.updateTranslation({
            task_id: taskId,
            original_index: fragment.index,
            translation_text: fragment.original,
        });
    }
}
